// extracted by mini-css-extract-plugin
export var chip = "_c2-0";
export var filterDropdown = "_c2-5";
export var filterItem = "_c2-6";
export var icon = "_c2-1";
export var removeButton = "_c2-3";
export var removeIcon = "_c2-4";
export var separator = "_c2-2";